// extracted by mini-css-extract-plugin
module.exports = {"list":"Menu-ltr_list__2Smri","title":"Menu-ltr_title__2qw2a","menuItemActive":"Menu-ltr_menuItemActive__3O3Ij","activeCurve":"Menu-ltr_activeCurve__vKh66"};